<template>
  <section class="section-base form-section-base">
    <div class="form-section-base__block-outer">
      <div class="form-section-base__block-inner">
        <div class="form-section-base__title">Подать заявление как:</div>
        <div class="form-section-base__controls">
          <v-row>
            <v-col>
              <v-radio-group v-model="fillType">
                <v-radio :label="manualLabel" :value="SubjectFillType.MANUAL"/>
                <v-radio
                    v-if="isAssigneeVisible"
                    :label="assigneeLabel"
                    :value="SubjectFillType.ASSIGNEE"
                />
                <v-radio
                    :label="SubjectFillTypeText.MACHINE"
                    :value="SubjectFillType.MACHINE"
                />
              </v-radio-group>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>

    <v-container>
      <Footer
        @next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
        first-step
        :loading-next="loadingNext"
      />
    </v-container>
  </section>
</template>

<script>
import { Role } from '@/utils/dictionaries';
import { leaveStep } from '@/utils/services';
import Footer from '@/components/services/elements/Footer';
import { StatementType, StepDirection, StepName } from '@/types/services';
import { ServicesModule } from '@/store/modules/services';
import {
  SubjectFillType,
  SubjectFillTypeText,
  SubjectName,
  SubjectType,
} from '@/constants';
import { getSubjectTitle } from '@/utils/common';

export default {
  name: 'SelectSubjectFillType',
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
    roleType: {
      type: String,
      required: true,
    },
    statementType: {
      type: String,
      required: true,
    },
    subjectName: {
      type: String,
      default: SubjectName.APPLICANT,
    },
  },
  components: {
    Footer,
  },
  data() {
    return {
      SubjectFillType,
      SubjectFillTypeText,
      StepDirection,
      StepName,
      leaveStep,
      Role,
      fillType: SubjectFillType.MANUAL,
      invalidFields: [],
    };
  },
  computed: {
    manualLabel() {
      return getSubjectTitle({
        statementType: this.statementType,
        subjectType: SubjectType.APPLICANT,
        role: this.roleType,
      });
    },

    isAssigneeVisible() {
      return this.statementType === StatementType.EGRN_CONFIRM;
    },

    assigneeLabel() {
      return getSubjectTitle({
        statementType: this.statementType,
        subjectType: SubjectType.ASSIGNEE,
        role: this.roleType,
      });
    },
  },
  created() {
    this.prefillDraft();
  },
  methods: {
    prefillDraft() {
      const fillType =
        ServicesModule.statement.subjects[this.subjectName]?.uiContext
          ?.fillType;

      if (fillType) this.fillType = fillType;
    },
    touchFields() {},
    assemblyModel() {
      return this.fillType;
    },
    btnSaveClickHandler(direction) {
      leaveStep({
        stepThis: this,
        direction,
        step: StepName.S1,
      });
    },
  },
};
</script>
